export default __webpack_public_path__ + "static/media/3050.c5a78924.jpg";